import type { MarketplaceListing } from '@siliconx/shared/dto/marketplace';
import { genericArtFor, listingImageModel, type ListingImageModel } from '@siliconx/shared/listing-image';
import { technicalDetailsOf } from '@siliconx/shared/ui/buyer-listing/listingShape';

/**
 * SIL-1451 - the image-or-fallback decision for a marketplace card.
 *
 * Photo: the API-resolved `listing.image` (SKU's own or family image, URL
 * already CDN-resolved). Absent/null (no image, unmatched asset, lot, or an API
 * one version behind): generic form-factor art from the asset class(es) the
 * listing already carries, so the slot never collapses.
 */
export function marketplaceListingImageModel(listing: MarketplaceListing, alt: string): ListingImageModel {
  const technical = technicalDetailsOf(listing);
  const art = genericArtFor({
    assetClassId: listing.assetClassId,
    assetTypeIds: listing.assetTypeIds,
    names: [listing.displayTitle, technical.serverModel],
    hasGpus: technical.gpuModel !== undefined || technical.gpusPerNode !== undefined,
    isServer: technical.serverModel !== undefined,
  });
  return listingImageModel({ image: listing.image, alt, art });
}
